import { FC, PropsWithChildren, useContext } from "react";
import { Link } from "react-router";
import styles from "./NavCard.module.scss";
import classNames from "classnames";

import { NavContent } from "./NavContent";
import { NavIcon } from "./NavIcon";
import { NavIllustration } from "./NavIllustration";
import { NavDropdown } from "./NavDropdown";
import { NavCardProps } from "./NavCard.props";
import { NavTag } from "./NavTag";
import { NavContext } from "../NavContext";

export interface NavCardSubComponents {
  Content: typeof NavContent;
  Icon: typeof NavIcon;
  Illustration: typeof NavIllustration;
  Tag: typeof NavTag;
}

/**
 * The navigation item component.
 */
export const NavCard: FC<PropsWithChildren<NavCardProps>> & NavCardSubComponents = (props: PropsWithChildren<NavCardProps>) => {
  const { id, testId, children, className, path } = props;

  const navContext = useContext(NavContext);
  const navCardClasses = classNames("nav-card", styles.navCard, className, `in-${navContext}`);
  const fullTestId = testId ? `test__${testId}-nav-card` : undefined;

  if (path) {
    return (
      <Link id={id} data-testid={fullTestId} className={navCardClasses} to={path}>
        {children}
        <NavDropdown />
      </Link>
    );
  }

  return (
    <div id={id} data-testid={fullTestId} className={navCardClasses}>
      {children}
      <NavDropdown />
    </div>
  );
};

NavCard.Content = NavContent;
NavCard.Icon = NavIcon;
NavCard.Illustration = NavIllustration;
NavCard.Tag = NavTag;
